/**
 * @packageDocumentation
 * @module api.functional.admin.users.promote
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponse__object } from "../../../../structures/ServiceResponse__object";
import type { ServiceResponsenull } from "../../../../structures/ServiceResponsenull";

/**
 * @controller UserController.promoteToManager
 * @path POST /admin/users/promote/:id
 * @accessor api.functional.admin.users.promote.promoteToManager
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function promoteToManager(
  connection: IConnection,
  id: string,
): Promise<promoteToManager.Output> {
  return PlainFetcher.fetch(connection, {
    ...promoteToManager.METADATA,
    template: promoteToManager.METADATA.path,
    path: promoteToManager.path(id),
  });
}
export namespace promoteToManager {
  export type Output = ServiceResponse__object | ServiceResponsenull;

  export const METADATA = {
    method: "POST",
    path: "/admin/users/promote/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = (id: string) =>
    `/admin/users/promote/${encodeURIComponent(id?.toString() ?? "null")}`;
}
